import { Component, OnInit, ViewChild, AfterContentInit, AfterViewInit } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { AppSettings } from '../../../app.constant';
import { Student } from '../../../shared/interface/student';
import { DataSource } from '@angular/cdk/table';
import { FormControl } from '@angular/forms';
import { Program } from 'src/app/shared/class/program';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { BatchService } from 'src/app/shared/services/batch.service';
import { StudentsService } from 'src/app/shared/services/students.service';

@Component({
  selector: 'app-students-table',
  templateUrl: './students-table.component.html',
  styleUrls: ['./students-table.component.css'],
  animations: [
    trigger('popOverState', [
      state('show', style({
        opacity: 1,
      })),
      state('hide', style({
        opacity: 0,
        display: 'none'
      })),
      transition('show => hide', animate('600ms ease-out')),
      transition('hide => show', animate('1000ms ease-in'))
    ]),

    trigger('popOverTable', [
      state('hide', style({
        opacity: 0,
        display: 'none'
      })),
      state('show', style({
        opacity: 1
      })),
      transition('hide => show', animate('600ms ease-out')),
      transition('show => hide', animate('1000ms ease-in'))
    ])
  ]
})


export class StudentsTableComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['EnrolmentNo', 'FirstName', 'LastName', 'DateOfBirth', 'MobileNo', 'PassportNo'];
  // filter values
  filteredValues = { BatchCode: '', BatchName: '', EnrolmentNo: '', PK_StudentID: '', FirstName: '', LastName: '', DateOfBirth: '', EmailID: '' }
  filterPredicate: any;
  programs: any;
  studentForm: FormGroup;
  FK_ProgramID: any;
  FK_BatchID: any = null;
  PK_BatchID: any = null;
  FK_ModuleID: any;
  selectedProgram: Program = new Program(0, 'ABC', 'asd', 'sadasdsa');
  show = false;
  tableShow = false;
  post: any;
  public resultdata: any;
  dataSource;
  errorMessage: String;
  progressBar: boolean = false;
  modules: any;
  batches: any;
  resultdata1: any;

  get stateName() {
    return this.show ? 'show' : 'hide'
  }

  get tableToggleName() {
    return this.tableShow ? 'hide' : 'show'
  }

  toggle() {
    this.show = !this.show;
    this.tableShow = !this.tableShow

    if (!this.tableShow) {
      let label = document.getElementsByClassName('mat-form-field-label');
      for (let i = 0; i < label.length; i++) {
        label[i].setAttribute("style", "white");
      }
    }
    // else {
    //   let label = document.getElementsByClassName('mat-form-field-label');
    //   for (let i = 0; i < label.length; i++) {
    //     label[i].setAttribute("style", "color:white;");
    //   }
    // }
  }

  // filter Form contorls ==========>
  nameFilter = new FormControl();
  batchFilter = new FormControl();
  enrolmentFilter = new FormControl();
  genderFilter = new FormControl();
  // =================================

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private formbuilder: FormBuilder,
    private _studentservice: StudentsService,
    private _programservice: ProgramService,
    private _moduleservice: ModuleService,
    private _batchservice: BatchService,

  ) { }

  ngOnInit() {
    this.studentForm = this.formbuilder.group({
      'FK_ProgramID': [''],
      'FK_ModuleID': [''],
      'FK_BatchID': [''],
      'EnrollmentNo': [''],
      'FK_StudentID': [],
      'ExamEntities': this.formbuilder.array([])
    })

    // filter by name
    this.nameFilter.valueChanges.subscribe((nameFilterValue) => {
      this.filteredValues['FirstName'] = nameFilterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
    });

    // filter by batch code
    this.batchFilter.valueChanges.subscribe((batchFilterValue) => {
      this.filteredValues['BatchCode'] = batchFilterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
    });

    // filter by Enrolment number
    this.enrolmentFilter.valueChanges.subscribe((enrolmentFilterValue) => {
      this.filteredValues['EnrolmentNo'] = enrolmentFilterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
    });


    this.getAllProgram();
  }

  ngAfterViewInit() {
    let element = document.querySelectorAll('.mat-form-field-infix');
    for (let i = 0; i < element.length; i++) {
      element[i].setAttribute("style", "width:100%; color:#fff;");
    }

    let arrow = document.getElementsByClassName('mat-sort-header-arrow');
    for (let i = 0; i < arrow.length; i++) {
      arrow[i].setAttribute("style", "color:#f5f908");
    }

    // let label = document.getElementsByClassName('mat-form-field-label');
    // for (let i = 0; i < label.length; i++) {
    //   label[i].setAttribute("style", "color:white;font-size:11px;");
    // }

    let label1 = document.getElementsByClassName('formlabel');
    for (let i = 0; i < label1.length; i++) {
      label1[i].setAttribute("style", "color:#AAAAAA;");
    }
  }

  getAllProgram(): void {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT + AppSettings.GetAllProgram).subscribe(
      data => {
        this.programs = data;
      },
      error => this.errorMessage = <any>error)
  }

  getModuleByProgramID(FK_ProgramID): void {
    this.FK_ProgramID = FK_ProgramID;
    var o = {
      PK_ProgramID: FK_ProgramID
    }
    this.post = JSON.stringify(o);

    this.getBatchByProgramID(FK_ProgramID);
    this._moduleservice.getModuleByProgramID(AppSettings.API_ENDPOINT + AppSettings.GetModuleByProgramID, this.post).subscribe(
      data => {
        this.modules = data;
        //this.modules= this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
      },
      error => this.errorMessage = <any>error)
  }

  getBatchByProgramID(PK_ProgramID): void {
    var o = { PK_ProgramID: PK_ProgramID }
    this.post = JSON.stringify(o);

    this._batchservice.GetBatchByProgramID(AppSettings.API_ENDPOINT + AppSettings.GetBatchByProgramID, this.post)
      .subscribe(
        data => {
          this.batches = data;
          // this.batches= this.batch.filter((item) => item.FK_ProgramID == PK_ProgramID);
        },
        error => this.errorMessage = <any>error)
  }

  getBatchID(FK_BatchID) {
    this.FK_BatchID = FK_BatchID;
  }

  getModuleID(FK_ModuleID) {
    this.FK_ModuleID = FK_ModuleID;
  }

  getStudentsByParam(FK_BatchID) {
    this.FK_BatchID = FK_BatchID;
    var o = {
      FK_ProgramID: this.FK_ProgramID,
      FK_ModuleID: this.FK_ModuleID,
      FK_BatchID: this.FK_BatchID,
    }

    this.post = JSON.stringify(o);
    this._studentservice.getStudentsByParam(AppSettings.API_ENDPOINT + AppSettings.GetStudentsByParam, this.post)
      .subscribe(result => {
        this.resultdata = result;

        this.progressBar = false;
        if (!result) {
          return;
        }

        this.dataSource = new MatTableDataSource<Student>(this.resultdata);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = this.customFilterPredicate();
      });
  }

  getallStudents() {
    this._studentservice.getAllStudents(AppSettings.API_ENDPOINT + AppSettings.GetAllStudents)
      .subscribe(result => {
        this.resultdata = result;
        this.progressBar = false;
        if (!result) {
          return;
        }

        this.dataSource = new MatTableDataSource<Student>(this.resultdata);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = this.customFilterPredicate();
      });
  }

  public GetStudentByEnrolment(exams) {
    var o = { PK_StudentID: exams.PK_StudentID }
    this.post = JSON.stringify(o);
    this.show = !this.show;
    this.tableShow = !this.tableShow;
    this._studentservice.getStudentByID(AppSettings.API_ENDPOINT + AppSettings.GetStudentByID, this.post)
      .subscribe(result => {
        this.resultdata1 = result;
        this._studentservice.changeMessage(this.resultdata1);
      });
  }

  // custom table filter function
  customFilterPredicate() {
    const myFilterPredicate = function (data: Student, filter: string): boolean {
      let searchString = JSON.parse(filter);
      return data.FirstName.toString().trim().toLowerCase().indexOf(searchString.FirstName.toLowerCase()) !== -1 &&
        // data.BatchCode.toString().trim().toLowerCase().indexOf(searchString.BatchCode.toLowerCase()) !== -1 &&
        data.EnrolmentNo.toString().trim().toLowerCase().indexOf(searchString.EnrolmentNo.toLowerCase()) !== -1;
      //  &&
      // data.Gender.toString().trim().toLowerCase().indexOf(searchString.Gender.toLowerCase()) !== -1;
    }
    return myFilterPredicate;
  }

  getValue(event: any) {
    let value = event.target.value;

  }
}

